var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"mb-6 md:mb-12"},[_c('vs-divider',[_c('vs-button',{attrs:{"color":"warning","size":"large"},on:{"click":function($event){$event.preventDefault();return _vm.$router.push('/kalkulator-zakat')}}},[_c('strong',{staticClass:"text-dark"},[_vm._v("Kalkulator Zakat")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }